import { Button } from "@components/ui/button"
import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import { BuiltInProviderType } from "next-auth/providers/index"
import { ClientSafeProvider, LiteralUnion, signIn } from "next-auth/react"
import Link from "next/link"
import { FC } from "react"

type SignupProps = {
  providers: Record<
    LiteralUnion<BuiltInProviderType, string>,
    ClientSafeProvider
  > | null
}

export const Signup: FC<SignupProps> = ({ providers }) => {
  // @ts-ignore
  const google = providers && providers.google
  // @ts-ignore
  const apple = providers && providers.apple
  return (
    <div className="flex flex-wrap justify-center md:justify-start w-full">
      <Heading variant="h2" className="mb-8">
        New to Viesus
      </Heading>
      <div className="flex items-center w-full flex-col">
        {(google || apple) && (
          <>
            {google && (
              <Button
                variant="secondary"
                leftIcon="google"
                onClick={() => signIn(google.id as any)}
                className="mb-4"
                width="fill"
              >
                Continue with Google
              </Button>
            )}
            {apple && (
              <Button
                variant="secondary"
                leftIcon="apple"
                className="mb-4"
                onClick={() => signIn(apple.id as any)}
                width="fill"
              >
                Continue with Apple
              </Button>
            )}
            <Text variant="micro" className="mb-4 text-shade-400">
              or
            </Text>
          </>
        )}

        <Link href="/signup/create-account" passHref legacyBehavior>
          <Button variant="primary" as="link" width="fill" className="mb-8">
            Continue with email
          </Button>
        </Link>
        <Text variant="small" className="bg-default bg-clip-text text-transparent">
          {"Already have an account? "}
          {
            <Link
              href="/login"
              passHref
              className={cn(
                "bg-hover bg-size-[0%_1px] bg-no-repeat bg-bottom-left",
                "transition-[background-size] duration-150 ease-in-out no-underline"
              )}
            >
              Log in
            </Link>
          }
          !
        </Text>
      </div>
    </div>
  )
}
